module.exports = __webpack_public_path__ + "assets/icon_docking.097c5900.svg";